var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors != null && _vm.errors.global != null)?_c('v-alert',{attrs:{"text":"","prominent":"","type":"error","icon":"mdi-cloud-alert"}},_vm._l((_vm.errors.global),function(error,key){return _c('div',{key:_vm.random + '-error-' + key},[_vm._v(" "+_vm._s(error)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }